<template>
  <div>
    <BaseWeb :logo-img="logoPhoto"
             :app-img-arr="appPhotoArr" :app-name="appName" :company="companyName" :icp-num="icpNum"
    class="many_recruit_btn"></BaseWeb>
  </div>

</template>

<script>
import BaseWeb from '../components/baseWeb'
export default {
  name: "duoduo",
  components:{
    BaseWeb:BaseWeb
  },
  data(){
    return{
      logoPhoto:require('../assets/manyRecruitImg/logo.png'),
      appPhotoArr:[
        {id:1,photo:require('../assets/manyRecruitImg/one.png')},
        {id:2,photo:require('../assets/manyRecruitImg/tow.png')},
        {id:3,photo:require('../assets/manyRecruitImg/three.png')},
        {id:4,photo:require('../assets/manyRecruitImg/four.png')},
      ],
      appName:'兼职多多',
      companyName:'上海藤玩网络科技有限公司',
      icpNum:'沪ICP备2020028940号-1',

    }
  }
}
</script>

<style scoped>
.many_recruit_btn{
  --downBtn:rgb(0,185,229);
}
</style>



// WEBPACK FOOTER //
// src/components/duoduo.vue